import React, { useState } from "react";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faPlay, faPlayCircle } from "gatsby";
import { Link } from "gatsby";
import SearchBar from "../pages/search-bar/ParentComponent";

const Sidebar = () => {
  // Create an array of dropdown objects
  const initialDropdowns = [
    {
      mainOpen: false,
      subOpen: [false, false],
    },
    {
      mainOpen: false,
      subOpen: [false, false, false],
    },
    {
      mainOpen: false,
      subOpen: [],
    },
    {
      mainOpen: false,
      subOpen: [],
    },
    {
      mainOpen: false,
      subOpen: [],
    },
    {
      mainOpen: false,
      subOpen: [],
    },
  ];

  // Create a function to toggle the main dropdown state
  const toggleMainDropdown = (index) => {
    const updatedDropdowns = [...dropdowns];
    updatedDropdowns[index].mainOpen = !updatedDropdowns[index].mainOpen;
    // Close all other main dropdowns when one is opened
    updatedDropdowns.forEach((dropdown, i) => {
      if (i !== index) {
        dropdown.mainOpen = false;
      }
    });
    setDropdowns(updatedDropdowns);
  };

  // Create a function to toggle a sub dropdown state
  const toggleSubDropdown = (dropdownIndex, subIndex) => {
    const updatedDropdowns = [...dropdowns];
    // Toggle the state of the clicked sub-dropdown
    updatedDropdowns[dropdownIndex].subOpen[subIndex] =
      !updatedDropdowns[dropdownIndex].subOpen[subIndex];

    // Close all other sub-dropdowns in the same main dropdown
    updatedDropdowns[dropdownIndex].subOpen = updatedDropdowns[
      dropdownIndex
    ].subOpen.map((sub, i) => (i === subIndex ? sub : false));

    setDropdowns(updatedDropdowns);
  };

  const [dropdowns, setDropdowns] = useState(initialDropdowns);

  return (
    <div className="sidenav">
      <SearchBar />
      <h2 className="sidenav-topic">Product Category</h2>
      {/* Main Dropdown 1 */}
      <button className="dropdown-btn" onClick={() => toggleMainDropdown(0)}>
        {dropdowns[0].mainOpen ? (
          <span style={{ color: "#7e743e" }}>&#9660;</span>
        ) : (
          <span style={{ color: "#7e743e" }}>►</span>
        )}
        &nbsp; <Link to="/product-category/industrial/">Industrial</Link>
      </button>

      {dropdowns[0].mainOpen && (
        <div className="dropdown-container">
          {/* sub-dropdown 1 links here */}
          <button
            className="dropdown-btn"
            onClick={() => toggleSubDropdown(0, 0)}
          >
            {dropdowns[0].subOpen[0] ? (
              <span style={{ color: "#7e743e" }}>&#9660;</span>
            ) : (
              <span style={{ color: "#7e743e" }}>►</span>
            )}
            &nbsp;{" "}
            <Link to="/product-category/industrial/construction/">
              Construction
            </Link>
          </button>
          {dropdowns[0].subOpen[0] && (
            <div
              className="sub-dropdown-container"
              onClick={() => toggleSubDropdown(0)}
            >
              <Link to="/product-category/industrial/construction/angle-brooms/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>
                Angle Brooms
              </Link>
              <Link to="/product-category/industrial/construction/bannisters/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Bannisters
              </Link>
              <Link to="/product-category/industrial/construction/cement-finishers/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Cement Finishers
              </Link>
              <Link to="/product-category/industrial/construction/cotton-mops/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Cotton Mops
              </Link>
              <Link to="/product-category/industrial/construction/counter-dusters/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Counter Dusters
              </Link>
              <Link to="/product-category/industrial/construction/deck-scrubs/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Deck Scrubs
              </Link>
              <Link to="/product-category/industrial/construction/fine-sweeps/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Fine Sweeps
              </Link>
              <Link to="/product-category/industrial/construction/garage-brooms/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Garage Brooms
              </Link>
              <Link to="/product-category/industrial/construction/hand-scrubs/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Hand Scrubs
              </Link>
              <Link to="/product-category/industrial/construction/heavy-sweeps/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Heavy Sweeps
              </Link>
              <Link to="/product-category/industrial/construction/medium-sweeps/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Medium Sweeps
              </Link>
              <Link to="/product-category/industrial/construction/squeegees/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Squeegees
              </Link>
              <Link to="/product-category/industrial/construction/synthetic-mops/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Synthetic Mops
              </Link>
              <Link to="/product-category/industrial/construction/upright-brooms/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Upright Brooms
              </Link>
              <Link to="/product-category/industrial/construction/window-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Window Brushes
              </Link>
              <Link to="/product-category/industrial/construction/wire-scratch-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Wire Scratch Brushes
              </Link>
              <Link to="/product-category/industrial/construction/yard-and-street-brooms/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Yard and Street Brooms
              </Link>
            </div>
          )}

          {/* sub-dropdown 2 links here */}
          <button
            className="dropdown-btn"
            onClick={() => toggleSubDropdown(0, 1)}
          >
            {dropdowns[0].subOpen[1] ? (
              <span style={{ color: "#7e743e" }}>&#9660;</span>
            ) : (
              <span style={{ color: "#7e743e" }}>►</span>
            )}
            &nbsp;{" "}
            <Link to="/product-category/industrial/masonry/">Masonry</Link>
          </button>
          {dropdowns[0].subOpen[1] && (
            <div
              className="sub-dropdown-container"
              onClick={() => toggleSubDropdown(0)}
            >
              <Link to="/product-category/industrial/masonry/application-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Application Brushes
              </Link>
              <Link to="/product-category/industrial/masonry/cement-finishers-masonry/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Cement Finishers
              </Link>
              <Link to="/product-category/industrial/masonry/crows-foot-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Crows Foot Brushes
              </Link>
              <Link to="/product-category/industrial/masonry/masonry-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Masonry Brushes
              </Link>
              <Link to="/product-category/industrial/masonry/roofing-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Roofing Brushes
              </Link>
              <Link to="/product-category/industrial/masonry/squeegees-masonry/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Squeegees
              </Link>
              <Link to="/product-category/industrial/masonry/stipple-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Stipple Brushes
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Main Dropdown 2 */}
      <button className="dropdown-btn" onClick={() => toggleMainDropdown(1)}>
        {dropdowns[1].mainOpen ? (
          <span style={{ color: "#7e743e" }}>&#9660;</span>
        ) : (
          <span style={{ color: "#7e743e" }}>►</span>
        )}
        &nbsp; <Link to="/product-category/commercial/">Commercial</Link>
      </button>
      {dropdowns[1].mainOpen && (
        <div className="dropdown-container">
          <button
            className="dropdown-btn"
            onClick={() => toggleSubDropdown(1, 0)}
          >
            {dropdowns[1].subOpen[0] ? (
              <span style={{ color: "#7e743e" }}>&#9660;</span>
            ) : (
              <span style={{ color: "#7e743e" }}>►</span>
            )}
            &nbsp;{" "}
            <Link to="/product-category/commercial/food-service/">
              Food Service
            </Link>
          </button>
          {dropdowns[1].subOpen[0] && (
            <div
              className="sub-dropdown-container"
              onClick={() => toggleSubDropdown(0)}
            >
              <Link to="/product-category/commercial/food-service/bannisters-food-service/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Bannisters
              </Link>
              <Link to="/product-category/commercial/food-service/counter-dusters-food-service/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Counter Dusters
              </Link>
              <Link to="/product-category/commercial/food-service/fine-sweeps-food-service/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Fine Sweeps
              </Link>
              <Link to="/product-category/commercial/food-service/heavy-sweeps-food-service/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Heavy Sweeps
              </Link>
              <Link to="/product-category/commercial/food-service/hygiene-range/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Hygiene Range
              </Link>
              <Link to="/product-category/commercial/food-service/medium-sweeps-food-service/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Medium Sweeps
              </Link>
              <Link to="/product-category/commercial/food-service/tank-kettle-brushes-food-service/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Tank & Kettle Brushes
              </Link>
              <Link to="/product-category/commercial/food-service/utility-brushes-food-service/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Utility Brushes
              </Link>
            </div>
          )}

          <button
            className="dropdown-btn"
            onClick={() => toggleSubDropdown(1, 1)}
          >
            {dropdowns[1].subOpen[1] ? (
              <span style={{ color: "#7e743e" }}>&#9660;</span>
            ) : (
              <span style={{ color: "#7e743e" }}>►</span>
            )}
            &nbsp;{" "}
            <Link to="/product-category/commercial/professional/">
              Professional
            </Link>
          </button>
          {dropdowns[1].subOpen[1] && (
            <div
              className="sub-dropdown-container"
              onClick={() => toggleSubDropdown(0)}
            >
              <Link to="/product-category/commercial/professional/angle-brooms-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Angle Brooms
              </Link>
              <Link to="/product-category/commercial/professional/bannisters-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Bannisters
              </Link>
              <Link to="/product-category/commercial/professional/bi-level-wash-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Bi-Level Wash Brushes
              </Link>
              <Link to="/product-category/commercial/professional/cobweb-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Cobweb Brushes
              </Link>
              <Link to="/product-category/commercial/professional/cotton-mops-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Cotton Mops
              </Link>
              <Link to="/product-category/commercial/professional/counter-dusters-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Counter Dusters
              </Link>
              <Link to="/product-category/commercial/professional/deck-scrubs-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Deck Scrubs
              </Link>
              <Link to="/product-category/commercial/professional/fine-sweeps-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Fine Sweeps
              </Link>
              <Link to="/product-category/commercial/professional/hand-scrubs-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Hand Scrubs
              </Link>
              <Link to="/product-category/commercial/professional/heavy-sweeps-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Heavy Sweeps
              </Link>
              <Link to="/product-category/commercial/professional/medium-sweeps-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Medium Sweeps
              </Link>
              <Link to="/product-category/commercial/professional/squeegees-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Squeegees
              </Link>
              <Link to="/product-category/commercial/professional/synthetic-mops-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Synthetic Mops
              </Link>
              <Link to="/product-category/commercial/professional/tank-kettle-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Tank & Kettle Brushes
              </Link>
              <Link to="/product-category/commercial/professional/toilet-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Toilet Brushes
              </Link>
              <Link to="/product-category/commercial/professional/truck-wash-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Truck Wash Brushes
              </Link>
              <Link to="/product-category/commercial/professional/upright-brooms-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Upright Brooms
              </Link>
              <Link to="/product-category/commercial/professional/utility-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Utility Brushes
              </Link>
              <Link to="/product-category/commercial/professional/window-brushes-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Window Brushes
              </Link>
              <Link to="/product-category/commercial/professional/wipers/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Wipers
              </Link>
              <Link to="/product-category/commercial/professional/yard-and-street-brooms-professional/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Yard and Street Brooms
              </Link>
            </div>
          )}

          <button
            className="dropdown-btn"
            onClick={() => toggleSubDropdown(1, 2)}
          >
            {dropdowns[1].subOpen[2] ? (
              <span style={{ color: "#7e743e" }}>&#9660;</span>
            ) : (
              <span style={{ color: "#7e743e" }}>►</span>
            )}
            &nbsp;{" "}
            <Link to="/product-category/commercial/vehicle-wash/">
              Vehicle Wash
            </Link>
          </button>
          {dropdowns[1].subOpen[2] && (
            <div
              className="sub-dropdown-container"
              onClick={() => toggleSubDropdown(0)}
            >
              <Link to="/product-category/commercial/vehicle-wash/fi-level-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Fi-Level Brushes
              </Link>
              <Link to="/product-category/commercial/vehicle-wash/radiator-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Radiator Brushes
              </Link>
              <Link to="/product-category/commercial/vehicle-wash/tirewall-brushes/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Tirewall Brushes
              </Link>
              <Link to="/product-category/commercial/vehicle-wash/utility-brushes-vehicle-wash/">
                <span style={{ color: "#7e743e", fontWeight: "bold" }}>
                  &#187;&nbsp;
                </span>{" "}
                Utility Brushes
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Main Dropdown 3 */}
      <button className="dropdown-btn" onClick={() => toggleMainDropdown(2)}>
        {dropdowns[2].mainOpen ? (
          <span style={{ color: "#7e743e" }}>&#9660;</span>
        ) : (
          <span style={{ color: "#7e743e" }}>►</span>
        )}
        &nbsp; <a href="/product-category/domestic/">Domestic</a>
      </button>
      {dropdowns[2].mainOpen && (
        <div
          className="sub-dropdown-container"
          onClick={() => toggleSubDropdown(0)}
        >
          <Link to="/product-category/domestic/angle-brooms-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Angle Brooms
          </Link>
          <Link to="/product-category/domestic/bannisters-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Bannisters
          </Link>
          <Link to="/product-category/domestic/bi-level-wash-brushes-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Bi-Level Wash Brushes
          </Link>
          <Link to="/product-category/domestic/cobweb-brushes-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Cobweb Brushes
          </Link>
          <Link to="/product-category/domestic/cotton-mops-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Cotton Mops
          </Link>
          <Link to="/product-category/domestic/counter-dusters-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Counter Dusters
          </Link>
          <Link to="/product-category/domestic/deck-scrubs-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Deck Scrubs
          </Link>
          <Link to="/product-category/domestic/dustpans/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Dustpans
          </Link>
          <Link to="/product-category/domestic/fine-sweeps-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Fine Sweeps
          </Link>
          <Link to="/product-category/domestic/hand-scrubs-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Hand Scrubs
          </Link>
          <Link to="/product-category/domestic/medium-sweeps-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Medium Sweeps
          </Link>
          <Link to="/product-category/domestic/nail-brushes/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Nail Brushes
          </Link>
          <Link to="/product-category/domestic/shoe-brushes/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Shoe Brushes
          </Link>
          <Link to="/product-category/domestic/synthetic-mops-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Synthetic Mops
          </Link>
          <Link to="/product-category/domestic/toilet-brushes-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Toilet Brushes
          </Link>
          <Link to="/product-category/domestic/truck-wash-brushes-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Truck Wash Brushes
          </Link>
          <Link to="/product-category/domestic/upright-brooms-domestic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Upright Brooms
          </Link>
        </div>
      )}

      {/* Main Dropdown 4 */}
      <button className="dropdown-btn" onClick={() => toggleMainDropdown(3)}>
        {dropdowns[3].mainOpen ? (
          <span style={{ color: "#7e743e" }}>&#9660;</span>
        ) : (
          <span style={{ color: "#7e743e" }}>►</span>
        )}
        &nbsp; <a href="/product-category/e-blocks/">Blocks</a>
      </button>
      {dropdowns[3].mainOpen && (
        <div
          className="sub-dropdown-container"
          onClick={() => toggleSubDropdown(0)}
        >
          <Link to="/product-category/e-blocks/plastic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Plastic
          </Link>
          <Link to="/product-category/e-blocks/wooden/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Wooden
          </Link>
        </div>
      )}

      {/* Main Dropdown 5 */}
      <button className="dropdown-btn" onClick={() => toggleMainDropdown(4)}>
        {dropdowns[4].mainOpen ? (
          <span style={{ color: "#7e743e" }}>&#9660;</span>
        ) : (
          <span style={{ color: "#7e743e" }}>►</span>
        )}
        &nbsp; <a href="/product-category/filaments/">Filaments</a>
      </button>
      {dropdowns[4].mainOpen && (
        <div
          className="sub-dropdown-container"
          onClick={() => toggleSubDropdown(0)}
        >
          <Link to="/product-category/filaments/animal-fibres/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Animal Fibres
          </Link>
          <Link to="/product-category/filaments/synthetic/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Synthetic
          </Link>
          <Link to="/product-category/filaments/vegetable-fibres/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Vegetable Fibres
          </Link>
        </div>
      )}

      {/* Main Dropdown 6 */}
      <button className="dropdown-btn" onClick={() => toggleMainDropdown(5)}>
        {dropdowns[5].mainOpen ? (
          <span style={{ color: "#7e743e" }}>&#9660;</span>
        ) : (
          <span style={{ color: "#7e743e" }}>►</span>
        )}
        &nbsp; <a href="/product-category/brands/">Brands</a>
      </button>
      {dropdowns[5].mainOpen && (
        <div
          className="sub-dropdown-container"
          onClick={() => toggleSubDropdown(0)}
        >
          <Link to="/product-category/brands/tip-top/">
            <span style={{ color: "#7e743e", fontWeight: "bold" }}>
              &#187;&nbsp;
            </span>{" "}
            Tip Top
          </Link>
        </div>
      )}

      <div>
        <a
          href="/Brushcatalogue/"
          target="_blank"
          // "https://bppl-holdings-catalogues.web.app/"
        >
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            style={{
              marginTop: "30px",
              backgroundColor: "#776e3a",
              color: "#ffffff",
              padding: "8px",
              fontFamily: "AvenirLTStd-Book, sans-serif",
              fontWeight: "300",
              fontSize: "15px",
              lineHeight: "20px",
              textDecoration: "none",
              border: "none",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#f4f4f4";
              e.target.style.color = "#776e3a";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#776e3a";
              e.target.style.color = "#f4f4f4";
            }}
          >
            &nbsp;&nbsp; Product Catalogue &nbsp;&nbsp;
          </button>
        </a>
      </div>
    </div>
  );
};

export default Sidebar;
